import Vue from "vue";
import DashboardPlugin from "./plugins/dashboard-plugin";
import App from "./App.vue";
import _ from "lodash";
import moment from "moment";
import router from "./routes/router";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import "nprogress/nprogress.css";

Vue.prototype.moment = moment;

// plugin setup
Vue.use(DashboardPlugin);
Vue.use(Loading, {
  fullPage: true,
  color: "#0088cc",
  backgroundColor: "#c2c2c2",
  loader: "spinner",
  height: 128,
  width: 128
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  render: h => h(App),
  router
});
